import React, { useState } from "react";
import Setting from "src/components/Layout/Setting";
import { useAppState } from "src/contexts/AppContext";

const Header = () => {
  const [setting, setSetting] = useState(false);
  const { state } = useAppState();
  ///uihhajshdsajkdhakjshdjkasdha
  // const [searchClicked, setsearchClicked] = useState(false);
  // // const togglesearch = () => {
  // //   setsearchClicked(!searchClicked);
  // // };
  const toggleSetting = (e) => {
    e.preventDefault();
    setSetting(!setting);
  };
  //// push test t

  return (
    <div className="main-header side-header">
      <div className="container-fluid">
        <div className="main-header-left ">
          <div
            className="app-sidebar__toggle mobile-toggle"
            data-toggle="sidebar"
          >
            <a
              className="open-toggle"
              href="/"
              onClick={(e) => e.preventDefault()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                className="eva eva-menu-outline header-icons"
              >
                <g data-name="Layer 2">
                  <g data-name="menu">
                    <rect
                      width={24}
                      height={24}
                      transform="rotate(180 12 12)"
                      opacity={0}
                    />
                    <rect
                      x={3}
                      y={11}
                      width={18}
                      height={2}
                      rx=".95"
                      ry=".95"
                    />
                    <rect
                      x={3}
                      y={16}
                      width={18}
                      height={2}
                      rx=".95"
                      ry=".95"
                    />
                    <rect x={3} y={6} width={18} height={2} rx=".95" ry=".95" />
                  </g>
                </g>
              </svg>
            </a>{" "}
            <a
              className="close-toggle"
              href="/"
              onClick={(e) => e.preventDefault()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                className="eva eva-close-outline header-icons"
              >
                <g data-name="Layer 2">
                  <g data-name="close">
                    <rect
                      width={24}
                      height={24}
                      transform="rotate(180 12 12)"
                      opacity={0}
                    />
                    <path d="M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z" />
                  </g>
                </g>
              </svg>
            </a>
          </div>
          <ul className="header-megamenu-dropdown  nav">
            <li
              className="nav-item"
              style={{
                display: "flex",
              }}
            >
              <div className="btn-group dropdown">
                <button
                  aria-expanded="false"
                  aria-haspopup="true"
                  className="btn btn-link dropdown-toggle"
                  data-toggle="dropdown"
                  id="dropdownMenuButton2"
                  type="button"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: window.innerWidth > 600 ? "9px 20px" : "5px 5px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <i className="fe fe-camera"></i>
                    <span
                      style={
                        window.innerWidth > 600
                          ? { display: "block" }
                          : { display: "none" }
                      }
                    >
                      Видео хурал
                    </span>
                  </span>
                </button>
                <div className="dropdown-menu">
                  <div className="">
                    <div>
                      <div className="setting-menu ">
                        <a
                          className="dropdown-item"
                          href="https://us02web.zoom.us/j/81792001211"
                        >
                          <i className="mdi mdi-account-outline tx-16 mr-2 mt-1"></i>
                          Ерөнхий захирлын шуурхай
                        </a>
                        <a
                          className="dropdown-item"
                          href="https://us02web.zoom.us/j/87178798694#success"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Үйлдвэрийн бүтцийн нэгжүүдийн өргөтгөсөн шуурхай
                        </a>
                        {/* <a
                          className="dropdown-item"
                          href="https://erdenetmc-mn.zoom.us/j/86245871013?pwd=U2p3em93anN4Ui9CYm1KYTdXZmtjdz09"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Их зогсолтын бэлтгэл ажлын хурал
                        </a> */}
                        <a
                          className="dropdown-item"
                          href="https://web.erdenetmc.mn/link/conference"
                        >
                          <i className="mdi mdi-account-location tx-16 mr-2"></i>
                          Бүтцийн нэгжүүдийн дотоод шуурхай
                        </a>
                        {/* <a
                          className="dropdown-item"
                          href="https://erdenetmc-mn.zoom.us/j/89812921508?pwd=YnNFL2ZQb0FqTlF0OXhPRHRmanc2QT09"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Нэн түрүүнд ХЭМАБ-2023 бага хурал
                        </a> */}
                        <a
                          className="dropdown-item"
                          href="https://erdenetmc-mn.zoom.us/j/89477661533?pwd=UHAxcHhqNE9Sc1lmaEwwSGlyaU0xdz09"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Үйл ажиллагааны тайлангийн хурал
                        </a>
                        <a
                          className="dropdown-item"
                          href="https://erdenetmc-mn.zoom.us/j/84919666781?pwd=cmJUSkxpcXVnVk5BMW5rajFNR01ydz09"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Их зогсолтын ажлын хэсгийн хурал
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              className="nav-item"
              style={{
                display: "flex",
              }}
            >
              <div className="dropdown-menu-rounded btn-group dropdown">
                <button
                  aria-expanded="false"
                  aria-haspopup="true"
                  className="btn btn-link dropdown-toggle"
                  data-toggle="dropdown"
                  id="dropdownMenuButton3"
                  type="button"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: window.innerWidth > 600 ? "9px 20px" : "5px 5px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <i className="nav-link-icon fe fe-briefcase"></i>
                    <span
                      style={
                        window.innerWidth > 600
                          ? { display: "block" }
                          : { display: "none" }
                      }
                    >
                      Холбоосууд
                    </span>
                  </span>
                </button>
                <div
                  className="dropdown-menu-lg dropdown-menu"
                  x-placement="bottom-left"
                >
                  <a
                    href="https://erdenetmc.mn/"
                    className="dropdown-item  mt-2"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="dropdown-icon"></i>Эрдэнэт үйлдвэр ТӨҮГ
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.erdenettoday.mn"
                  >
                    <i className="dropdown-icon"></i>Өнөөгийн эрдэнэт
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://spellcheck.erdenetmc.mn"
                  >
                    <i className="dropdown-icon"></i>Зөв бичгийн алдаа шалгуур
                  </a>
                  <a className="dropdown-item" href="../download/AnyDesk.exe">
                    <i className="dropdown-icon"></i>Anydesk татах
                  </a>
                  <a
                    className="dropdown-item"
                    href="http://papercutserver.erdenetmc.mn:9191/"
                  >
                    <i className="dropdown-icon"></i>Нийтийн принтер
                  </a>
                  <a
                    className="dropdown-item"
                    href="http://papercutserver.erdenetmc.mn:9163/setup"
                  >
                    <i className="dropdown-icon"></i>Принтер setup татах
                  </a>
                  <div className="dropdown-divider"></div>
                </div>
              </div>
            </li>
            <li
              className="nav-item "
              style={{
                display: "flex",
              }}
            >
              <a
                rel="noreferrer"
                className=" text-black"
                href="https://odoo.erdenetmc.mn/"
              >
                <div className="d-flex shadow-lg bg-white p-2 rounded-lg align-items-center cursor-hover">
                  <img
                    src="/img/odoo_logo_small.png"
                    alt="Loader"
                    style={{ width: "45px", height: "13px" }}
                  />
                  <span className="ms-2">&nbsp; ERP систем</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div className="main-header-right">
          <div className="nav nav-item  navbar-nav-right ml-auto">
            <div className="nav-item main-header-message ">
              <a
                className="new nav-link"
                href="https://sso.erdenetmc.mn/login"
                alt="sso login"
              >
                <i className="fe fe-user"></i>
              </a>
            </div>
            {state.isexternal === 0 && (
              <>
                <div className="nav-item main-header-message ">
                  <a
                    className="new nav-link"
                    href="https://web.erdenetmc.mn/link/phone/"
                  >
                    <i className="fe fe-phone"></i>
                  </a>
                </div>
                <div className="nav-item main-header-message ">
                  <a
                    className="new nav-link"
                    href="https://web.erdenetmc.mn/link/email/"
                    alt="Төрсөн өдөр"
                  >
                    <i className="fe fe-mail"></i>
                  </a>
                </div>
              </>
            )}

            <div
              className={
                setting
                  ? "dropdown  nav-item main-header-message show"
                  : "dropdown  nav-item main-header-message"
              }
            >
              <a
                className="new nav-link"
                href="/"
                onClick={(e) => toggleSetting(e)}
              >
                <i className="fe fe-settings" />
              </a>
              <div className="dropdown-menu">
                <Setting />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Header);
